import { ActionMethod, AssetType } from '../../api/models/Shared.types';
import { EpgUtil } from '../utility/EpgUtil';
import { Log } from '@lightningjs/sdk';
import { IRibbon2Asset, ISeasonV5 } from '../../api/models/AndromeTV.types';
import { Backend } from '../../api/Backend';
import { Recording } from '../../api/user/RecordingApi.types';
import { EpgApiV5 } from '../../api/EpgApiV5';

export function recordingToRibbon2Asset(backend: Backend, recording: Recording): Promise<IRibbon2Asset> {
  return EpgApiV5.schedule(backend, recording.schedule)
    .then(schedule => {
      const seasons = [schedule.season].filter(s => s) as ISeasonV5[];
      const asset: IRibbon2Asset = {
        asset: {
          type: AssetType.RECORDING,
          id: recording.identifier,
          image: schedule.program.image.poster || '',
          title: '',
          episode: recording.programOrdinal,
          minimumAge: schedule.program.minimumAge,
          adult: schedule.program.adult,
        },
        method: ActionMethod.DETAIL,
        channels: EpgUtil.schedulesToRibbon2Channels([schedule.schedule]),
        resources: [EpgUtil.programToRibbon2Detail(schedule.program, seasons)],
      };
      return asset;
    })
    .catch(error => {
      Log.error('Failed to fetch schedule for recording, falling back on programfallback: ', error);
      return recordingFallback(backend, recording);
    });
}

function recordingFallback(backend: Backend, recording: Recording): Promise<IRibbon2Asset> {
  return EpgApiV5.program(backend, recording.program).then(result => {
    const seasons = [result.season].filter(s => s) as ISeasonV5[];
    const asset: IRibbon2Asset = {
      asset: {
        type: AssetType.RECORDING,
        id: recording.identifier,
        image: result.program.image.poster || '',
        title: result.program.text.title,
        episode: recording.programOrdinal,
      },
      method: ActionMethod.DETAIL,
      channels: [
        {
          id: recording.channel,
          schedules: [
            {
              id: '',
              programId: result.program.programId,
              published: { start: recording.effectiveStart || '', end: recording.effectiveEnd || '' },
            },
          ],
        },
      ],
      resources: [EpgUtil.programToRibbon2Detail(result.program, seasons)],
    };
    return asset;
  });
}
